import {useMemo} from 'react'
import {useLocation} from 'react-router'

export function usePaymentOrder() {
  const {search, pathname} = useLocation()

  const is5Order = useMemo(() => search.includes('?version=cc'), [search])
  const randomId = useMemo(() => pathname.split('/')[2], [pathname])

  return {
    is5Order,
    randomId,
  }
}
